import {
  AfterViewInit,
  Directive,
  input,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { FieldOverflowModalComponent } from '@shared/components/field-overflow-modal/field-overflow-modal.component';

@Directive({
  standalone: false,
  selector: '[gstarTextareaOverflowButton]',
})
export class TextareaOverflowButtonDirective implements AfterViewInit {
  private readonly viewContainer = inject(ViewContainerRef);

  gstarTextareaOverflowButton = input<boolean>(false);
  fieldTitle = input<string>('');
  textContent = input<string>('');
  htmlElement = input<HTMLElement>();

  private currentScrollHeight = 0;
  private resizeObserver?: ResizeObserver;

  ngAfterViewInit(): void {
    this.setupResizeObserver();
    this.addOverflowButton();
  }
  private addOverflowButton(): void {
    if (this.gstarTextareaOverflowButton()) {
      const element = this.htmlElement();
      if (!element) {
        return;
      }

      const isOverflowing = element.scrollHeight > element.offsetHeight;

      if (isOverflowing) {
        const componentRef = this.viewContainer.createComponent(
          FieldOverflowModalComponent
        );
        const instance = componentRef.instance;

        instance.modalTitle = this.fieldTitle;
        instance.modalContent = this.textContent;
        componentRef.setInput('isHtmlContent', this.isHtml(this.textContent()));
        componentRef.changeDetectorRef.detectChanges();
      }
    }
  }

  private setupResizeObserver(): void {
    const element = this.htmlElement();
    if (!element) {
      return;
    }

    this.currentScrollHeight = element.scrollHeight;

    this.resizeObserver = new ResizeObserver(() => {
      const newScrollHeight = element.scrollHeight;
      if (newScrollHeight !== this.currentScrollHeight) {
        this.currentScrollHeight = newScrollHeight;
        this.addOverflowButton();
      }
    });
    this.resizeObserver.observe(element);
  }

  private isHtml(text: string): boolean {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    return doc.body?.children?.length > 0;
  }
}
